<template>
  <div class="payment-complete">
    <v-container v-if="breakpoint !== 'xs'">
      <v-row justify="space-between" align="center">
        <!-- Volver a perfil -->
        <v-card class="payment-complete__card payment-complete__card--side">
          <v-img
            class="payment-complete__check mx-auto my-4"
            src="@/assets/images/ico-search.webp"
            width="90"
            contain
          />
          <v-btn to="/organization/home" class="payment-complete__btn" text>
            VOLVER A TU PERFIL
          </v-btn>
        </v-card>

        <!-- Mensaje -->
        <v-card class="payment-complete__card payment-complete__card--main">
          <!-- Success -->
          <v-container v-if="isPaymentComplete">
            <h2 class="payment-complete__title">Pago exitoso</h2>
            <p class="payment-complete__text">Estás listo para comenzar tu búsqueda</p>
            <v-icon class="payment-complete__icon payment-complete__icon--success">
              mdi-check-circle
            </v-icon>
            <v-btn
              class="payment-complete__btn"
              to="/organization/payments"
              text
            >
              IR A PAGOS
            </v-btn>
          </v-container>

          <!-- Failure -->
          <v-container v-else>
            <h2 class="payment-complete__title">
              Hubo un error al procesar tu pago
            </h2>
            <v-icon class="payment-complete__icon payment-complete__icon--error">
              mdi-alert-circle-outline
            </v-icon>
            <v-btn to="/checkout" class="payment-complete__btn" text>
              VUELVE A INTENTARLO
            </v-btn>
          </v-container>
        </v-card>

        <!-- Nueva publicación -->
        <v-card class="payment-complete__card payment-complete__card--side">
          <v-img
            class="payment-complete__check mx-auto my-4"
            src="@/assets/images/oferta.webp"
            width="90"
            contain
          />
          <v-btn to="/offers/post" class="payment-complete__btn" text>
            NUEVA PUBLICACIÓN
          </v-btn>
        </v-card>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-col>
        <!-- Mensaje -->
        <v-card class="payment-complete__card-mobile mx-auto mb-10">
          <!-- Success -->
          <v-container v-if="isPaymentComplete">
            <h2 class="payment-complete__title">Pago exitoso</h2>
            <p class="payment-complete__text">Estás listo para comenzar tu búsqueda</p>
            <v-icon class="payment-complete__icon payment-complete__icon--success">
              mdi-check-circle
            </v-icon>
            <v-btn
              class="payment-complete__btn-mobile"
              @click="getInvoice(invoicePath)"
              :disabled="!invoicePath"
              text
            >
              <span class="payment-complete__btn-mobile--download">
                DESCARGA TU COMPROBANTE
              </span>
            </v-btn>
          </v-container>

          <!-- Failure -->
          <v-container v-else>
            <h2 class="payment-complete__title">
              Hubo un error al procesar tu pago
            </h2>
            <v-icon class="payment-complete__icon payment-complete__icon--error">
              mdi-alert-circle-outline
            </v-icon>
            <v-btn to="/checkout" class="payment-complete__btn-mobile" text>
              <span class="payment-complete__btn-mobile--download">
                VUELVE A INTENTARLO
              </span>
            </v-btn>
          </v-container>
        </v-card>
        
        <!-- Nueva publicación -->
        <v-card class="payment-complete__card-mobile mx-auto my-5">
          <v-img
            class="payment-complete__check mx-auto my-4"
            src="@/assets/images/oferta.webp"
            width="150"
            contain
          />
          <v-btn to="/offers/post" class="payment-complete__btn-mobile" text>
            NUEVA PUBLICACIÓN
          </v-btn>
        </v-card>

        <!-- Volver a perfil -->
        <v-card class="payment-complete__card-mobile mx-auto mt-10">
          <v-img
            class="payment-complete__check mx-auto my-4"
            src="@/assets/images/ico-search.webp"
            width="150"
            contain
          />
          <v-btn to="/organization/home" class="payment-complete__btn-mobile" text>
            VOLVER A TU PERFIL
          </v-btn>
        </v-card>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { tools } from "@/libs/mixins";
import { meta } from "@/libs/mixins";

export default {
    name: "PaymentComplete",

    mixins: [meta, tools],

    metaInfo() {
        return this.getMetaInfo({
            title: "Detalles de compra",
        });
    }, 

    computed: {
        ...mapGetters("payments", ["paymentStatus", "invoicePath"]),

        isPaymentComplete() {
            return this.paymentStatus;
        }
    },

    methods: {
        ...mapActions("cookies", ["activity"]),
        
        getInvoice(filename) {
            let url = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_INVOICE_PATH + filename;
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = encodeURI(url);
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        }
    },
    
    mounted() {
        if (this.isPaymentComplete) {
            this.activity({
                path: this.$route.path,
                activity: "paymentComplete",
            });
        }
    }
};
</script>
